<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Fed</span>
        <span class="font-weight-light">Logistics</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
        flat
        @click="notesDialog = true"
      >
        <span @click="notesDialog = true">Notes</span>
      </v-btn>
      <v-btn
        flat
        @click="logout"
      >
        <span>Logout</span>
      </v-btn>
    </v-toolbar>
    <v-dialog v-model="notesDialog" max-width="800px">
      <Notes @close="notesDialog=false" />
    </v-dialog>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import Notes from './components/Notes';
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'App',
    components: {Notes},
    data() {
        return {
          notesDialog: false
        };
      },
    methods: {
        logout() {
            firebase.auth().signOut().then(() => {
                this.$router.push('/login');
            });
        }
    }
};
</script>
